export function DeliveryAddress() {
  function showPopover() {
    let searchInput = document.querySelector(".pac-target-input")
    let deliveryAddress = document.cookie.match(new RegExp('(^| )temp_delivery_address=([^;]+)'))

    if(!deliveryAddress && searchInput.dataset.address == 'Find your address') {
      $('#deliver-to-wrapper').popover('show');
      searchInput.focus();
    }
  }

  return {
    showPopover,
  }
}